import script from "./SpecialTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialTemp.vue?vue&type=script&setup=true&lang=js"

import "./SpecialTemp.vue?vue&type=style&index=0&id=25c163b5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c163b5"]])

export default __exports__